import { render, staticRenderFns } from "./ResourceContent.vue?vue&type=template&id=4f3c43f3&scoped=true&"
import script from "./ResourceContent.vue?vue&type=script&lang=js&"
export * from "./ResourceContent.vue?vue&type=script&lang=js&"
import style0 from "./ResourceContent.vue?vue&type=style&index=0&id=4f3c43f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c43f3",
  null
  
)

export default component.exports